import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

import { examsAPI } from 'common/api/examsAPI'

export const fetchTasks = createAsyncThunk(
  'exam/fetchTasks',
  async (id: string, { rejectWithValue }) => {
    try {
      return await examsAPI.getTasks(id)
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  }
)
